module.exports = __webpack_public_path__ + "static/img/bg2.09c8e3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new/bg2.png
// module id = 9QhM
// module chunks = 0